exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row-bg[data-v-3f9cf7c3] {\n  flex-wrap: wrap;\n  gap: 0 6%;\n}\n", ""]);

// exports
